<template>
    <div class="plan"
         @click="$emit('clickToImage')">
        <div v-if="images?.length > 1"
             class="plan__dynamic">
            <!-- Если устройство десктоп и имеется массив с
            изображениями помещения то выводим карусель изображений -->
            <div v-if="!isMobile"
                 :key="listKey"
                 class="plan__dynamic-wrapper">
                <template v-for="(image, index) in images">
                    <div
                        v-show="index === activePlan"
                        :key="index"
                        class="plan__dynamic-item">
                        <img
                            :src="image"
                            :alt="altText">
                    </div>
                </template>
            </div>

            <div v-if="!isMobile"
                 class="plan__dynamic-lines"
                 @click="openPlan">
                <div v-for="(image, index) in images"
                     :key="index"
                     :class="['plan__dynamic-lines-line', {'is-active': activePlan === index}]"
                     @mouseenter="activePlan = index" />
            </div>

            <!-- Если мобила и не табличный вид - выводим слайдер -->
            <Swiper v-if="isMobile"
                    :pagination="true"
                    :slides-per-view="1"
                    :space-between="0"
                    :centered-slides="true"
                    class="plan__dynamic-swiper"
                    @slideChange="onSlideChange"
                    @click="openPlan">
                <SwiperSlide
                    v-for="(image, index) in images"
                    :key="`${index}-${Math.random(0, 100)}`">
                    <img
                        :src="image"
                        :alt="altText">
                </SwiperSlide>
            </Swiper>

            <template v-if="imageZoom">
                <span class="plan__overlay" />
                <div class="plan__zoom-text">
                    Нажмите чтобы увеличить
                </div>
            </template>
        </div>

        <button v-else-if="images?.length"
                class="plan__button"
                @click="openPlan">
            <img class="plan__image"
                 :src="images[0]"
                 :alt="altText">
            <template v-if="imageZoom">
                <span class="plan__overlay" />
                <div class="plan__zoom-text">
                    Нажмите чтобы увеличить
                </div>
            </template>
        </button>

        <div class="plan__zoom-mobile"
             @click="openPlan">
            <IconZoomMini />
        </div>

        <Teleport to="body">
            <PlanPopup ref="showPopup"
                       :name="name"
                       :area="area"
                       :src-image="images[activePlan]"
                       :alt-text="altText" />
        </Teleport>
    </div>
</template>

<script>
import IconZoomMini from '@/components/Icons/ZoomMini.vue';
import PlanPopup from './PlanPopup';
import Teleport from 'vue2-teleport';
import {Swiper, SwiperCore, SwiperSlide} from 'swiper-vue2';
import {Pagination} from 'swiper';
import 'swiper/swiper-bundle.css';

SwiperCore.use([Pagination]);

export default {
    name: 'FlatPlan',

    components: {
        IconZoomMini,
        PlanPopup,
        Teleport,
        Swiper,
        SwiperSlide
    },

    props: {
        images    : Array,
        altText   : String,
        name      : String,
        area      : [Number, String],
        isMobile  : Boolean,
        planInline: {
            type   : Boolean,
            default: false
        },
        imageZoom: {
            type   : Boolean,
            default: true
        }
    },

    data() {
        return {
            // Текущий отображаемые план
            activePlan: 0,
            // ключ для ререндера при изменении массива
            listKey   : 0
        };
    },

    watch: {
        activePlan() {
            this.listKey++;
        }
    },

    methods: {
        openPlan() {
            if (!this.imageZoom) {
                return;
            }

            this.$refs.showPopup.openPlan();
        },

        onSlideChange(swiper) {
            this.activePlan = swiper.activeIndex;
        }
    }
};
</script>

<style lang="scss">
@import "Plan";
</style>
